import { http, HttpResponse, delay } from "msw";

const appointments = [
    {
        "id": "e39d8b96-08a0-4ec1-9c2c-e5371f170f04",
        "start_date": new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10) + "T15:00:00.000Z",
        "end_date": new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10) + "T16:00:00.000Z",
        "purpose": "Ejemplo #3",
        "status": "completed",
        "assigned_user_id": "8d571c79-3642-43d1-999a-49b508d95ca2",
        "customer": {
            "id": "1b7cfe3b-4c16-4abe-9d19-e49c5466fdea",
            "name": "Laaguilar",
            "email": "luis@okboy.app",
            "phone": "6622600048"
        },
        "order": null
    },
    {
        "id": "6571b592-f990-43d8-93c0-c4b4c93a0959",
        "start_date": new Date().toISOString().slice(0, 10) + "T14:00:00.000Z",
        "end_date": new Date().toISOString().slice(0, 10) + "T15:30:00.000Z",
        "purpose": "Para una orden",
        "status": "completed",
        "assigned_user_id": "8d571c79-3642-43d1-999a-49b508d95ca2",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com",
            "phone": "6622050973"
        },
        "order": null
    },
    {
        "id": "3c4a4caf-71d5-4b91-95a5-0457a788e8a8",
        "start_date": new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10) + "T15:30:00.000Z",
        "end_date": new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10) + "T19:00:00.000Z",
        "purpose": "Tatuaje mamalón",
        "status": "completed",
        "assigned_user_id": "8d571c79-3642-43d1-999a-49b508d95ca2",
        "customer": {
            "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            "name": "Luis Aguilar",
            "email": "luis.aguilar.rocha@gmail.com",
            "phone": "6622050973"
        },
        "order": {
            "id": "b9609240-490b-4fae-b341-05e0d71962d5",
            "folio": "NAC-034",
            "total": 0,
            "status": "open",
            "order_type": "service"
        }
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}/appointments`

export const appointmentsHandlers = [
    http.get(`${baseUrl}`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            appointments,
            { status: 200 }
        );
    }),
    http.post(`${baseUrl}`, async ({ request }) => {
        await delay(2100);

        const body = await request.json();

        const newAppointment = {
            "id": "faf90d36-65d8-4cea-b261-6f0733e5b0d2",
            "start_date": body.start_date,
            "end_date": body.end_date,
            "purpose": body.purpose,
            "status": "scheduled",
            "assigned_user_id": "8d571c79-3642-43d1-999a-49b508d95ca2",
            "customer": {
                "id": "1b7cfe3b-4c16-4abe-9d19-e49c5466fdea",
                "name": "Laaguilar",
                "email": "luis@okboy.app",
                "phone": "6622600048"
            },
            "order": null
        }

        appointments.push(newAppointment);

        return HttpResponse.json(
            newAppointment,
            { status: 201 }
        );
    }),
    http.put(`${baseUrl}/:id`, async ({ params, request }) => {
        await delay(2100);

        const appointment = appointments.find(app => app.id === params.id);

        if (!appointment) {
            return HttpResponse.json(
                { error: "Appointment not found" },
                { status: 404 }
            );
        }

        const updatedAppointment = await request.json();

        appointment.start_date = updatedAppointment.start_date;
        appointment.end_date = updatedAppointment.end_date;
        appointment.purpose = updatedAppointment.purpose;
        appointment.status = updatedAppointment.status;
        appointment.assigned_user_id = updatedAppointment.assigned_user_id;
        appointment.customer = updatedAppointment.customer;
        appointment.order = updatedAppointment.order;

        return HttpResponse.json(
            appointment,
            { status: 200 }
        );
    }),
    http.delete(`${baseUrl}/:id`, async ({ params }) => {
        await delay(2100);

        const appointment = appointments.find(app => app.id === params.id);

        if (!appointment) {
            return HttpResponse.json(
                { error: "Appointment not found" },
                { status: 404 }
            );
        }

        appointments.splice(appointments.indexOf(appointment), 1);

        return HttpResponse.json(
            { message: "Appointment deleted successfully" },
            { status: 200 }
        );
    })
];
